import {createTheme} from '@mui/material/styles';

export const _theme = createTheme({
    typography: {
        fontFamily: [
            'BrownPro',
            'Roboto',
        ].join(','),
    },
    palette: {
        primary: {
            main: '#F19100',
            contrastText: '#FFFFFF',
        },
        secondary: {
            main: '#D00032',
            contrastText: '#FFFFFF',
        },
        contrastThreshold: 3,
    },
});
